import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = true

// 引入 ui框架
import Element from 'element-ui';
import locale from 'element-ui/lib/locale';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)

//引入请求
import axios from "axios";
import api from './utlis/api';
Vue.prototype.api = api
import preventReClick from './utlis/preventReClick' //防多次点击，重复提交

//引入图标
import '@/assets/css/iconfont.css'
//	引入全局css
import '@/assets/css/reset.css'
//引入全局变量
import '@/assets/css/main.scss'
//  封装全局js
import xin from './utlis/xin'
Vue.prototype.xin = xin;

//引入全局过滤器
import * as filters from './utlis/filters'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})


// 引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)


import router from "@/router/router"
import store from '@/store/store'
router.afterEach((to,from,next) => {
	window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

